'use strict';

/* global $ */

import ValidateJs from './../../../vendor/jquery.validate';

import { ITGWebservice } from './../../../services/ITGWebservice';
import { cookieManager } from './../../../services/CookieManager';
import { goToNextStep, goToPrevStep, gtm_virtualpage_track, jsonifyForm, zipcodeRestrict } from './../_form_functions.js';
import { AnalyticsUserIds } from './../../analytics_user_ids';
import './../_validateRules';

import ErrorMsg from './../../errorMsg';

export default recall => {
    console.log('recall', recall);

    let analyticsUserIds = new AnalyticsUserIds();

    let form_1 = $('#formStep_1');
    let form_2 = $('#formStep_2');
    let form_captcha = $('#formStep_captcha');

    let form_1_data_send = false;
    let form_2_data_send = false;


    /* COOKIES HANDLER : PRE-FILL & UPDATE
    -------------------------------------------------------------------------- */
    // au load renseigner [name="referring_website"] [name="arrival_url"]
    if (cookieManager.getCookieValue(cookieManager.site_referrer)) {
        $('[name="referring_website"]').val(cookieManager.getCookieValue(cookieManager.site_referrer));
    }
    if (cookieManager.getCookieValue(cookieManager.site_arrival)) {
        $('[name="arrival_url"]').val(cookieManager.getCookieValue(cookieManager.site_arrival));
    }

    // présélectionner [name="contact_reason_id"] en fonction de la provenance
    let previous_user_visit = cookieManager.getCookieValue(cookieManager.user_lastvisit);
    if (previous_user_visit === 'Question') {
        $('[name="contact_reason_id"]').val(1);
        $('.customSelect').addClass('hidden');
        $('[name="ask_question"]').addClass('hidden');
        $('.ask_question').addClass('hidden');
    } else if (previous_user_visit === 'Simulateur') {
        $('[name="contact_reason_id"]').val(14);
    } else if (previous_user_visit === 'Devenir consultant') {
        $('[name="contact_reason_id"]').val(1);
    } else if (previous_user_visit === 'Agenda atelier') {
        $('[name="contact_reason_id"]').val(12);
    } else if (previous_user_visit === 'Agenda formation') {
        $('[name="contact_reason_id"]').val(12);
    }

    // préremplir les champs si ils sont présents dans le cookie
    $('[name="lastname"]').val(cookieManager.getCookieValue(cookieManager.user_lastname));
    $('[name="firstname"]').val(cookieManager.getCookieValue(cookieManager.user_firstname));
    $('[name="phone"]').val(cookieManager.getCookieValue(cookieManager.user_phone));
    $('[name="zipcode"]').val(cookieManager.getCookieValue(cookieManager.user_zipcode));
    $('[name="email"]').val(cookieManager.getCookieValue(cookieManager.user_email));

    let updateCookie = () => {
        // Cookie handler
        cookieManager.store({
            [cookieManager.user_lastvisit]: 'Rappel',
            [cookieManager.user_lastname]: $('[name="lastname"]').val(),
            [cookieManager.user_firstname]: $('[name="firstname"]').val(),
            [cookieManager.user_phone]: $('[name="phone"]').val(),
            [cookieManager.user_zipcode]: $('[name="zipcode"]').val(),
            [cookieManager.user_email]: $('[name="email"]').val()
        });
    };

    /* ZIPCODE
    -------------------------------------------------------------------------- */
    zipcodeRestrict();


    /* GTM
    -------------------------------------------------------------------------- */
    gtm_virtualpage_track($('#formStep_1'));
    
    
    /* CAPTCHA
    -------------------------------------------------------------------------- */
    let initCaptcha = () => {
    	if ($('#formStep_captcha').find('.g-recaptcha-response').length && $('#formStep_captcha').find('.g-recaptcha-response').val() == '')
    	{
    		if (typeof grecaptcha == 'object')
			{
				grecaptcha.execute();
				console.log('captcha EXECUTE');
			}
			
			setTimeout(function(){ initCaptcha(); }, 1000);
		}
    };
    $(document).ready(function() {
    	setTimeout(function(){ initCaptcha(); }, 1000);
	});


    /* FORM VALIDATION & DATA & AJAX SUBMIT
    -------------------------------------------------------------------------- */
    // validation
    let formStep_1__validate = () => {
        form_1.validate({
            errorClass: 'inputError',
            highlight: function (element) {
                $(element).closest('.formEntry').addClass('formError');
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest('.formEntry').removeClass('formError');
            },
            rules: {
                field_secteur: {
                    required: true
                },
                select_mission: {
                    required: true
                },
                phone: {
                    minlength: 10,
                    digits: true
                },
                email: {
                    required: true,
                    strictEmail: true
                },
                zipcode: {
                    required: true,
                    number: true,
                    digits: true,
                    minlength: 5,
                    maxlength: 5
                }
            },
            messages: {
                field_secteur: 'Veuillez choisir un secteur d\'activité',
                select_mission: 'Veuillez choisir une situation',
                firstname: 'Veuillez saisir votre prénom',
                lastname: 'Veuillez saisir votre nom',
                phone: 'Veuillez saisir votre numéro de téléphone',
                email: {
                    required: 'Veuillez saisir votre adresse mail',
                    email: 'Veuillez saisir une adresse mail valide',
                    strictEmail: 'Veuillez saisir une adresse mail valide'
                },
                zipcode: {
                    required: 'Veuillez renseigner votre code postal',
                    number: 'Veuillez renseigner un code postal à 5 chiffres',
                    digits: 'Veuillez renseigner un code postal à 5 chiffres',
                    minlength: 'Veuillez renseigner un code postal à 5 chiffres',
                    maxlength: 'Veuillez renseigner un code postal à 5 chiffres'
                }
            }
        });
    };

    let formStep_2__validate = () => {
        form_2.validate({
            errorLabelContainer: '.js-errorPopinList',
            errorElement: 'li',
            errorClass: 'inputError',
            highlight: function (element) {
                $(element).closest('.formEntry').addClass('formError');
            },
            unhighlight: function (element, errorClass, validClass) {
                $(element).closest('.formEntry').removeClass('formError');
            },
            rules: {
                ask_question: {
                    required: () => {
                        let option = $('[name="contact_reason_id"] option:selected');
                        let optionTexte = option.text();
                        let optionValue = option.val();
                        return ((optionValue === '1' && optionTexte === 'Demande de renseignements') || optionValue === '5');
                    }
                }
            },
            messages: {
                ask_question: 'Veuillez précisez votre demande'
            }
        });
    };

    // data
    let collectData = () => {
        // Form Json for WS
        let forms = form_1.serializeArray().concat(form_2.serializeArray(), form_captcha.serializeArray());

        let formJson = {};
        formJson.contact = jsonifyForm(forms);
        let comment = {};
        comment.user_question = $('[name="ask_question"]').val();
        // Ajouter les les champs du simulateur en comment
        if (cookieManager.getCookieValue(cookieManager.user_simulator_salary)) {
            comment[cookieManager.user_simulator_salary] = cookieManager.getCookieValue(cookieManager.user_simulator_salary);
        }
        if (cookieManager.getCookieValue(cookieManager.user_simulator_billing)) {
            comment[cookieManager.user_simulator_billing] = cookieManager.getCookieValue(cookieManager.user_simulator_billing);
        }
        if (cookieManager.getCookieValue(cookieManager.user_become_consultant)) {
            comment[cookieManager.user_become_consultant] = cookieManager.getCookieValue(cookieManager.user_become_consultant);
        }

        formJson.contact['comment'] = comment;

        // DEBUG: Display the key/value pairs
        console.log('DATA WS', formJson);

        return formJson;
    };

    // ajax
    let sendData1 = () => {
        var formJson = collectData();
        
        var async = !(typeof grecaptcha == 'object');
        
        var res = ITGWebservice.sendRequest(ITGWebservice.rappel_url, ITGWebservice.endpoint_contact, formJson, 'json', async).done((data) => {
        	if (async) {
	            console.log('ANSWER WS', data);
	
	            if (data && data.error) {
	                const el = document.querySelector('#formStep_2.popinFormBox');
	                new ErrorMsg(data.error.httpcode, el);
	            } else {
	                let userIdObject = data.contact.target;
	                if (userIdObject.google_analytics_id_created) {
	                    console.log('creating user id as new');
	                    analyticsUserIds.setUserId(userIdObject.google_analytics_id, 'etre-rappele-1');
	                } else {
	                    console.log('not a new user id');
	                    analyticsUserIds.setUserId(userIdObject.google_analytics_id);
	                }
	            }
            }
        });
        
        if (!async) {
        	if (typeof res.responseJSON != 'undefined' && typeof res.responseJSON.error == 'string') {
        		alert(res.responseJSON.error);
        		return false;
        	}
        }

        dataLayer.push({
            'event': 'form_submit',
            'goal_type': 'Formulaire - Être rappelé',
            'form_name': 'Être rappelé',
            'form_type': 'Être rappelé'
        });
        
        return true;
    };

    let sendData = () => {
        var formJson = collectData();
        ITGWebservice.sendRequest(ITGWebservice.rappel_url, ITGWebservice.endpoint_contact, formJson, 'json').done((data) => {
            console.log('ANSWER WS', data);

            if (data && data.error && data.error.httpcode) {
                const el = document.querySelector('#formStep_2 .popinFormBox');
                new ErrorMsg(data.error.httpcode, el);
            } else {
                let userIdObject = data.contact.target;
                if (userIdObject.google_analytics_id_created) {
                    console.log('creating user id as new');
                    analyticsUserIds.setUserId(userIdObject.google_analytics_id, 'etre-rappele-2');
                } else {
                    console.log('not a new user id');
                    analyticsUserIds.setUserId(userIdObject.google_analytics_id);
                };
            }
        });
    };

    /* EVENT HANDLERS */
    form_1.on('submit', (e) => {
        e.preventDefault();
        formStep_1__validate();
        if (form_1.valid()) {
            if (sendData1())
            {
	            updateCookie();
                let target = $('.next', e.currentTarget);
                let current_fs = target.closest('.formStep');
                let next_fs = target.closest('.formStep').next();
                next_fs.find('.errorList').empty();
                next_fs.show();
                current_fs.hide();
	
	            try {
	                window.GQGoal('VALIDATION FORMULAIRE ETRE RAPPELE' + (window.location.href.indexOf('/business') >= 0 ? ' POPIN BUSINESS' : ''));
	            } catch (e) {
	            }
			}
        }
    });

    form_2.on('submit', (e) => {
        e.preventDefault();

        formStep_2__validate();
        if (form_2.valid() && !form_2_data_send) {
            form_2_data_send = true;
            sendData();
            updateCookie();
            goToNextStep($('.next', e.currentTarget));

            try {
                window.GQGoal('VALIDATION FORMULAIRE POSER UNE QUESTION' + (window.location.href.indexOf('/business') >= 0 ? ' POPIN BUSINESS' : ''));
            } catch (e) {
            }
        }
    });

    // POPIN CLOSE btn
    $('.fancybox-close-small').on('click', (e) => {
        // si les données n'ont pas été envoyées
        // et que l'étape 1 du formulaire est au moins passée
        if ((!form_2_data_send) && ($('#formStep_1').css('display') === 'none')) {
            updateCookie();
            sendData();
        }
    });

    $('.popinFormBox-close-inside').on('click', (e) => {
        e.preventDefault();
        $('.fancybox-close-small').trigger('click');
    });
    
    window.addEventListener('keypress', function (evt) {
	    if (evt.target.id == 'firstname' || evt.target.id == 'lastname')
	    {
	        evt = (evt) ? evt : window.event;
	        var charCode = (evt.which) ? evt.which : evt.keyCode;
	        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
	            return true;
	        } else {
	            evt.preventDefault();
	        }
	    }
	    else if (evt.target.id == 'phone')
	    {
	    	evt = (evt) ? evt : window.event;
	        var charCode = (evt.which) ? evt.which : evt.keyCode;
	        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
	            evt.preventDefault();
            } else if (evt.target.value.length >= 10) {
	            evt.preventDefault();
	        } else {
	            return true;
	        }
		}
	    
	});
};



// WEBPACK FOOTER //
// ./front/js/modules/forms/popins/recall.js